import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../../src/axios/index";
import Loader from "../../shared/Component/Loader";
import fileDownload from "js-file-download";
import axios from "axios";
// import { ImageUrlPrefix } from "../../labels";

const PdfPreviewPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();
  const tableRef = useRef();
  const { title, headers, rows, filename, autoPrint } = state || {};
  const handlePrint = () => {
    //  Check data availability before calling API
    if (!headers || headers.length === 0 || !rows || rows.length === 0) {
      console.warn("No data available, skipping PDF generation.");
      return;
    }
 
    const pdf_content = `
    <html>
      <head>
        <title>Print</title>
        <style>
          table {
            width: 100%;
            border-collapse: collapse;
          }
          th, td {
            padding: 8px;
            text-align: left;
            word-wrap: break-word;
            white-space: normal;
            max-width: 150px;
            border: 1px solid #ccc;
            font-size: 13px;
          }
          thead tr th {
            background-color: #041134;
            color: white;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          h2 {
            font-size: 20px;
            margin: 20px 0;
          }
        </style>
      </head>
      <body>
        <h2>${title || "Report"}</h2>
        ${tableRef.current?.innerHTML || ""}
      </body>
    </html>
  `;
    Download_Ans(pdf_content, filename);
  };
 
  useEffect(() => {
    if (autoPrint) {
      //  Only run handlePrint if rows/headers exist
      if (headers?.length > 0 && rows?.length > 0) {
        setTimeout(() => {
          handlePrint();
        }, 100);
      }
    }
  }, [autoPrint, headers, rows]);
 
  // Download PDF
  const Download_Ans = (content, file_name) => {
    setIsLoading(true);
    const now = new Date();
    const timestamp = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}_${String(
      now.getHours()
    ).padStart(2, "0")}-${String(now.getMinutes()).padStart(2, "0")}-${String(
      now.getSeconds()
    ).padStart(2, "0")}`;

    // Split the original file name to remove .pdf if exists
    const baseName = file_name.replace(/\.pdf$/i, "");

    // Final file name with timestamp
    const finalFileName = `${baseName}_${timestamp}.pdf`;

    AxiosInstance.post("api/all/generatePDF", {
      content: content,
      filename: finalFileName,
    })
      .then((res) => {
        console.log(res, " Response ");
        if (res.data.status === true) {
          // Add timestamp to avoid cache
          const pdfUrl = `${res.data.path}?t=${new Date().getTime()}`; // PDF URL from backend
          // Open PDF in new tab
          // window.open(pdfUrl, "_blank");
          setIsLoading(false);

          axios
            .get(`${pdfUrl}`, {
              responseType: "blob",
            })
            .then((res) => {
              fileDownload(res.data, filename);
            })
            .catch((error) => {
              console.error("Download failed:", error);
            });

          //  Redirect back to Current page
          // setTimeout(() => {
          navigate(-1);
          // }, 500);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  };
  if (!state) return <p>No data available</p>;
  return (
    <>
      <div className="row m-2" ref={tableRef}>
        <div className="col-12 p-0 px-lg-2">
          <div
            className="table-responsive"
            style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}
          >
            <table
              className="table"
              id="tableListHeader"
              style={{
                tableLayout: "fixed",
                width: "100%",
                minWidth: "600px", //
              }}
            >
              <thead>
                <tr>
                  {headers.map((h, i) => (
                    <th
                      key={i}
                      style={{
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        fontWeight: "bold",
                        fontSize: "14px",
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, rIndex) => (
                  <tr key={rIndex}>
                    {row.map((cell, cIndex) => (
                      <td
                        key={cIndex}
                        style={{
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                          maxWidth: "150px",
                          fontSize: "13px",
                        }}
                      >
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div
        className="loaderApi"
        style={{
          display: isLoading ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "white",
          zIndex: 999,
        }}
      >
        <Loader />
      </div>
    </>
  );
};
export default PdfPreviewPage;
 
 